export const buildSurveyTokenizeUrl = (
  item,
  {
    token = localStorage.token,
  } = {}
) => {
  if (!item?.url || !item?.instance || !token) return null;

  try {
    const survey = new URL(item.url);
    const allowedHosts = new Set([
      "surveys.feradel.com",
      ...String(process.env.REACT_APP_ALLOWED_SURVEY_HOSTS || "").split(",").map(host => host.trim().toLowerCase()).filter(Boolean),
    ]);
    if (survey.protocol !== "https:" || survey.username || survey.password || survey.port) return null;
    if (!allowedHosts.has(survey.hostname.toLowerCase())) return null;
    if (!survey.pathname.startsWith("/public/survey/")) return null;

    const next = `${survey.pathname}${survey.search}${survey.hash}`;
    const tokenize = new URL("/authentic/tokenize", survey.origin);
    tokenize.searchParams.set("t", token);
    tokenize.searchParams.set("i", item.instance);
    tokenize.searchParams.set("next", next);
    return tokenize.toString();
  } catch {
    return null;
  }
};
